import React  from 'react';
import "./animation.css";

function Animation() {
    return <div className="box"><b></b></div>;
}

export default Animation;



// WEBPACK FOOTER //
// ./src/components/home/animation/animation.js